/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createReducer } from 'redux-app/utils/reducer'

const MODULE_NAME = 'modal'

export const OPEN_MODAL = `${MODULE_NAME}/OPEN_MODAL`
export const CLOSE_MODAL = `${MODULE_NAME}/CLOSE_MODAL`

export const openModal = ({ name, data }: { name: string, data?: any }) => ({
  type: OPEN_MODAL,
  payload: { name, data },
})

export const closeModal = ({ name }) => ({
  type: CLOSE_MODAL,
  payload: { name },
})

const ACTION_HANDLERS = {
  [OPEN_MODAL]: (state, { payload: { name, data = {} } }) => ({
    ...state,
    [name]: {
      isOpen: true,
      data,
    },
  }),
  [CLOSE_MODAL]: (state, { payload: { name } }) => ({
    ...state,
    [name]: {
      isOpen: false,
      data: {},
    },
  }),
}

const initialState = {}

export default createReducer(initialState, ACTION_HANDLERS)
